import { render, staticRenderFns } from "./WidgetCarouselProductsTab.vue?vue&type=template&id=b019fb96&scoped=true"
import script from "./WidgetCarouselProductsTab.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselProductsTab.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselProductsTab.vue?vue&type=style&index=0&id=b019fb96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b019fb96",
  null
  
)

export default component.exports